import { useTranslation } from 'react-i18next';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { useRecordTypeOrder } from '../insights/useRecordTypeOrder';
import { configTablesOf } from './configTablesOf';
import { ConfigTablesGroup } from './ConfigTablesGroup';
import { designEntityLabel } from './designEntityRules';
import type { IConfigMenuGroupsProps } from './IConfigMenuGroupsProps';
import { menuSectionsOf } from './moduleSections';
import { RecordTypeGroups } from './RecordTypeGroups';

/**
 * Групи меню модуля без власного меню прототипу поза списками (прототип v4: налаштування, «Модель даних» і розділи-списки «Проєктування»
 * будують загальне меню головного типу, а не власні групи модуля чи розділи типів): групи головного типу з метаданих (RecordTypeGroups:
 * «Моя робота», «Черга», «Склад»…), а в налаштуваннях і «Моделі даних» ще розгорнута група «Таблиці» — головна, дочірні таблиці й
 * сутності прототипу (configTablesOf, ConfigTablesGroup; дочірні — у порядку модулів простору з каталогу).
 */
export function ConfigMenuGroups({ ws, moduleKey, module, main, moduleName, withTables, openState }: IConfigMenuGroupsProps) {
  const { t } = useTranslation();
  const { lang } = useModuleStrings(moduleKey);
  const sections = menuSectionsOf(module);
  const orderOf = useRecordTypeOrder(ws);
  const tables = withTables && sections.tables ? configTablesOf(module, (rtKey, i, e) => designEntityLabel(lang, moduleKey, rtKey, i, e), orderOf) : [];
  return (
    <>
      <RecordTypeGroups ws={ws} moduleKey={moduleKey} moduleName={moduleName} rt={main} planning={sections.planning} openState={openState} />
      <ConfigTablesGroup ws={ws} moduleKey={moduleKey} tables={tables} title={t('menu.tables')} openState={openState} />
    </>
  );
}
